/**
 * @generated SignedSource<<b2a3311d3b80ed0c32b359768e671c50>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserCommentsPageFragment$data = {
  readonly comments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly topic: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"TopicListItemFragment">;
        };
        readonly " $fragmentSpreads": FragmentRefs<"CommentDisplayFragment">;
      };
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "UserCommentsPageFragment";
};
export type UserCommentsPageFragment$key = {
  readonly " $data"?: UserCommentsPageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCommentsPageFragment">;
};

import UserCommentsPageFragmentPaginationQuery_graphql from './UserCommentsPageFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "comments"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": UserCommentsPageFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "UserCommentsPageFragment",
  "selections": [
    {
      "alias": "comments",
      "args": [
        {
          "kind": "Literal",
          "name": "order",
          "value": "NEWEST"
        }
      ],
      "concreteType": "CommentConnection",
      "kind": "LinkedField",
      "name": "__UserCommentsPageFragment_comments_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CommentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Comment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Topic",
                  "kind": "LinkedField",
                  "name": "topic",
                  "plural": false,
                  "selections": [
                    (v1/*:: as any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "TopicListItemFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CommentDisplayFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__UserCommentsPageFragment_comments_connection(order:\"NEWEST\")"
    },
    (v1/*:: as any*/)
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "1661731c7dd3bb4f9cf82f9ab1a4ecc7";

export default node;
